import React from "react";
import IntlMessages from "../../../../../utils/messages";
import Table from "../../../../../components/Table";
import { displayDayDDMMYYYY_HHMM } from "../../../../../utils/config";
import { GroundGraphqlContextStore } from "../../../../../lib/ground-aws-graphql-core";
import { QuoteRequestServiceSelection } from "../../../../../lib/ground-aws-graphql-core/models/Api/QuoteRequests";
import { getTranslation } from "../../../../../utils/translation";

interface Props {
  selections: QuoteRequestServiceSelection[] | undefined;
  title: string;
}

const QuoteRequestServiceSelections = (props: Props): JSX.Element => {
  const { selections, title } = props;

  const centerTimezone = GroundGraphqlContextStore.useStoreState(
    state => state.center.centerTimezone
  );

  const selectionsTableHead = [
    "general.service",
    "general.name",
    "general.booking",
    "general.quantity",
    "general.description",
  ];

  const selectionsTableBody = selections?.map(selection => {
    const {
      service,
      product,
      start_date,
      end_date,
      total_participants,
      quantity,
      description,
    } = selection;

    const hasBooking = start_date && end_date;
    const bookingDates = `${displayDayDDMMYYYY_HHMM(
      start_date,
      centerTimezone
    )} > ${displayDayDDMMYYYY_HHMM(end_date, centerTimezone)}`;

    return {
      id: selection.id.toString(),
      rowElements: [
        { element: getTranslation(service.label) },
        { element: product ? getTranslation(product?.name) : "-" },
        {
          element: hasBooking ? (
            <p className="flex flex-col">
              <span>{bookingDates}</span>
              <span>
                <IntlMessages
                  id="page.detail.quote.request.selections.booking.persons"
                  values={{
                    total: total_participants,
                  }}
                />
              </span>
            </p>
          ) : (
            "-"
          ),
        },
        {
          element: quantity,
        },
        { element: getTranslation(description) },
      ],
    };
  });

  return (
    <div className="bg-white shadow sm:rounded-lg my-30px">
      <div className="px-4 py-5 border-b border-gray-200 sm:px-6">
        <h3 className="text-16px leading-6 font-medium text-gray-900">
          <IntlMessages id={title} />
        </h3>
      </div>
      <Table
        head={selectionsTableHead}
        body={selectionsTableBody}
        noDataText="general.list.empty"
        className="px-3 py-5"
      />
    </div>
  );
};

export default QuoteRequestServiceSelections;
